import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from 'jquery';
import 'multiple-select/dist/multiple-select.min.js';
import 'multiple-select/dist/multiple-select.min.css';
import './form-item-instalment-relief.component.scss';
var FormItemInstalmentRelief = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemInstalmentRelief, _super);
    function FormItemInstalmentRelief(element) {
        return _super.call(this, element) || this;
    }
    FormItemInstalmentRelief.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.assistanceRequiredSelect = this.element.querySelector('select[name=assistance-required]');
        this.updateDatePicker("");
        $(document).ready(function () {
            $(".js-multi-select__instalment-relief").multipleSelect({ placeholder: "Please select", selectAll: false });
        });
    };
    FormItemInstalmentRelief.prototype.bindEvents = function () {
        var _this = this;
        this.applyFormSubmit.map(function (item) { return item.addEventListener("click", function (event) {
            var formFields = _this.applyForm.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_this.applyForm.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_this.applyForm);
            }
        }); });
        if (this.assistanceRequiredSelect) {
            this.assistanceRequiredSelect.addEventListener("change", function (pEvent) {
                var _target = pEvent.target;
                _this.updateDatePicker(_target.value);
            });
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
    };
    FormItemInstalmentRelief.prototype.updateDatePicker = function (pAssistance) {
        var _dateInput = this.element.querySelector("input[name=instalment-relief-start-date]");
        if (_dateInput) {
            var _dateFormGroup = _dateInput.closest(".form__group");
            switch (pAssistance) {
                case "Instalment relief":
                    _dateFormGroup.classList.remove("form__group--hidden");
                    _dateInput.classList.add("form__input--required");
                    break;
                default:
                    _dateFormGroup.classList.add("form__group--hidden");
                    _dateInput.classList.remove("form__input--required");
                    break;
            }
        }
    };
    FormItemInstalmentRelief.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            var formContainerLoader = this.element.querySelector(".form__loader--container");
            var formContainerFields = this.element.querySelector(".form__fields--container");
            var formContainerThankyou = this.element.querySelector(".form__thankyou--container");
            formContainerThankyou.classList.remove("active");
            formContainerFields.classList.remove("hidden");
            $(".js-multi-select__instalment-relief:selected").prop("selected", false);
            $(".js-multi-select__instalment-relief").multipleSelect("refresh");
        }
    };
    FormItemInstalmentRelief.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // fields
        // const fields: any = this.formsService.serializeForm(form);
        var postData = "";
        var _recipient = form.querySelector("input[name=recipient]");
        var _email = form.querySelector("input[name=email]");
        var _description = form.querySelector("input[name=description]");
        var _assistanceRequired = form.querySelector("select[name=assistance-required]");
        var _subject = form.querySelector("input[name=subject]");
        var _instalmentReliefStartDate = form.querySelector("input[name=instalment-relief-start-date]");
        var _firstName = form.querySelector("input[name=first-name]");
        var _surname = form.querySelector("input[name=surname]");
        var _idNumber = form.querySelector("input[name=id-number]");
        var _contactNumber = form.querySelector("input[name=contact-number]");
        postData += "recipient=" + (_recipient ? _recipient.value : "");
        postData += "&email=" + (_email ? _email.value : "");
        postData += "&description=" + (_description ? _description.value : "");
        postData += "&assistance-required=" + (_assistanceRequired ? _assistanceRequired.value : "");
        postData += "&subject=" + (_subject ? _subject.value + " " + _assistanceRequired.value : "");
        postData += "&instalment-relief-start-date=" + (_instalmentReliefStartDate ? _instalmentReliefStartDate.value : "");
        postData += "&first-name=" + (_firstName ? _firstName.value : "");
        postData += "&surname=" + (_surname ? _surname.value : "");
        postData += "&id-number=" + (_idNumber ? _idNumber.value : "");
        postData += "&contact-number=" + (_contactNumber ? _contactNumber.value : "");
        var responseFormat = form.querySelector("select[name = products]");
        var options = "";
        if (responseFormat) {
            for (var i = 0; i < responseFormat.options.length; i++) {
                if (responseFormat.options[i].selected) {
                    options += responseFormat.options[i].value + ", ";
                }
            }
            options = options.substring(0, options.length - 2);
        }
        postData += "&products=" + (options ? options : "");
        postData += "&service-type=";
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/genericform.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove("active");
            analyticsService.dtmFormComplete("complete", "");
            thankYou.classList.add("active");
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete("complete", "");
            loader.classList.remove("active");
            thankYou.classList.add("active");
        });
    };
    return FormItemInstalmentRelief;
}(Base));
export { FormItemInstalmentRelief };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-instalment-relief/form-item-instalment-relief.component.ts
// module id = 916
// module chunks = 0